import React from 'react'
import { DATA } from '../../data/header-data'
import { Link } from 'react-router'
import { useLenis } from 'lenis/react';
import { useTranslation } from 'react-i18next';

const Footer = () => {

  const { t } = useTranslation();
    const lenis = useLenis();

    const handleScrollToTop = () => {
        if (lenis) {
            lenis.scrollTo(0);
        }
    };

    const { i18n } = useTranslation();
    const currentLang = i18n.language



    return (
        <div className='relative md:sticky bottom-0 z-0'>
            <div className='w-full grid grid-cols-11 lg:grid-cols-7  bg-genesisBlue   '>
                <div className='col-start-2 col-span-9 lg:col-start-2 lg:col-span-5 z-50 py-20  '>
                    <div className=' space-y-14'>

                        <div className=' w-full  flex justify-between items-center'>
                            <Link to={'/'}><img src='/images/genesis-logo.svg' className='!h-10' /></Link>

                            <img onClick={handleScrollToTop} src='/images/icons/up-arrow.svg' className='h-4 cursor-pointer' />

                        </div>













                        <div className='w-full grid grid-cols-1 md:grid-cols-4 lg:grid-cols-7 gap-x-3 gap-y-10'>
            {DATA.map((section, index) => (
                <div key={index}>
                    <Link to={section.link}>
                        <h2 className="font-medium mb-4 text-16 text-white duration-300 hover:text-customGold1">
                            {section.title[currentLang]}
                        </h2>
                    </Link>
                    <ul>
                        {section.dropDown?.map((item, subIndex) => (
                            <li key={subIndex}>
                                <Link to={item.link} className="font-light hover:text-misuraBlue transition-all text-16 text-white duration-300 hover:text-customGold1">
                                    {item.title[currentLang]}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>



                        <div className='text-16 flex flex-col text-white space-y-3'>
                            <h2 className="font-medium  ">{t('iletisim')}</h2>
                            <a href='https://maps.app.goo.gl/wvt59ZX73vTx3ubz8' target='_blank' className='duration-300 hover:text-customGold1 cursor-pointer !block'>Tantavi̇ Mah. Estergon Cad. Exen İstanbul F Blok
                                No: 24 F İç Kapi No: 29 Ümrani̇ye/  İstanbul</a>
                            <a href='tel:+905318591156' target='_blank' className='duration-300 hover:text-customGold1 cursor-pointer !block' >+90 531 859 11 56</a>
                            <a href='mailto:info@genesiscs.com.tr' target='_blank' className='duration-300 hover:text-customGold1 cursor-pointer !block' >info@genesiscs.com.tr</a>

                            <div className=' w-full  flex space-x-2 pt-10'>
                                <img src='/images/social-icons/f.svg' className='hover:scale-105 duration-300 cursor-pointer'/>
                                <img src='/images/social-icons/i.svg' className='hover:scale-105 duration-300 cursor-pointer'/>
                                <img src='/images/social-icons/li.svg' className='hover:scale-105 duration-300 cursor-pointer'/>
                            </div>
                        </div>


                    </div>
                </div>

            </div>

            <div className='  bg-white w-full grid grid-cols-11 lg:grid-cols-7 relative'>

                <div className='col-start-2 col-span-9 lg:col-start-2 lg:col-span-5 z-50bg-red-900 h-16 flex  items-center  justify-between text-black text-14'>
                    <p className='duration-300 '> {t('genesis-tum-haklari')}</p>
                    <a target='_blank' href='https://macart.com.tr/'><p className='duration-300 hover:scale-105 cursor-pointer'>MACART</p></a>
                </div>



            </div>
        </div>
    )
}

export default Footer